<template>
  <PageWrapper
    :isLoading="isLoading"
    cardClass="shadow-none"
    isChildWrapper
    isDense
  >
    <template #title> قیمت های شخصی سازی شده استاد </template>
    <template v-if="priceCategoryDetails">
      <PriceCategoryCustomPercentSection
        v-for="item in priceCategoryDetails"
        :key="item.priceCateogryId"
        :customPercentDetails="item"
        @getPriceCategoryDetails="setPriceCategoryDetails"
        @refetch="getMasterPriceCategoryDetails"
      ></PriceCategoryCustomPercentSection>
    </template>
  </PageWrapper>
</template>

<script>
export default {
  emits: ["getPriceCategoryUsers"],
  props: {
    masterUserId: {
      type: [Number, String],
      required: true,
    },
  },
  mounted() {
    this.getMasterPriceCategoryDetails();
  },
  data() {
    return {
      isLoading: false,
      priceCategoryDetails: null,
    };
  },
  methods: {
    setPriceCategoryDetails(priceCategoryDetails) {
      this.$emit("getPriceCategoryUsers", priceCategoryDetails);
    },
    async getMasterPriceCategoryDetails() {
      try {
        this.isLoading = true;
        const _this = this;
        const getMasterPriceCategoriesDetails =
          new GetMasterPriceCategoriesDetails(_this);
        getMasterPriceCategoriesDetails.setRequestParam({
          userId: _this.masterUserId,
        });
        await getMasterPriceCategoriesDetails.fetch((res) => {
          _this.priceCategoryDetails = res.data;
        });
      } catch (error) {
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    PageWrapper,
    PriceCategoryCustomPercentSection,
  },
};

import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import PriceCategoryCustomPercentSection from "@/views/apps/PriceCategory/PriceCategoryCustomPercentSection.vue";
import { GetMasterPriceCategoriesDetails } from "@/libs/Api/Users";
</script>
